import { render, staticRenderFns } from "./itemReleaseManageList.vue?vue&type=template&id=d7edf15e&scoped=true"
import script from "./itemReleaseManageList.vue?vue&type=script&lang=js"
export * from "./itemReleaseManageList.vue?vue&type=script&lang=js"
import style0 from "./itemReleaseManageList.vue?vue&type=style&index=0&id=d7edf15e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7edf15e",
  null
  
)

export default component.exports